import React from "react";
import { Alert } from "@mui/material";
import AppModal from "../common/AppModal";
import CreateOrUpdateCustomerForm from "../../forms/CreateOrUpdateCustomerForm";

const CreateCustomerModal = ({ open, onClose, loading, error }) => (
  <AppModal
    open={open}
    onClose={onClose}
    title="Add New Customer"
    width="sm"
    loading={loading}
  >
    {error && (
      <Alert severity="error" sx={{ mb: 2 }}>
        {error}
      </Alert>
    )}
    <CreateOrUpdateCustomerForm loading={loading} />
  </AppModal>
);
export default CreateCustomerModal;
